
function initialiseDescriptionLink() {
    const link = document.querySelector(".description-link");
    const description = document.querySelector(".product-single__box__block--description");

    if (link && description) {
        link.addEventListener("click", () => {
            description.scrollIntoView({
                behavior: "smooth",
            });
        })
    }
}

function mobileStickyATC() {
    toggleSticky();

    document.addEventListener("scroll", (e) => {
        toggleSticky();
    });
}

function toggleSticky() {
    const buyButton = document.querySelector(".product-form__add-wrapper");
    if (buyButton) {
        const buttonRect = buyButton.getBoundingClientRect();
        const buttonBottom = buttonRect.bottom;

        if (buttonBottom < 0) {
            document.querySelector(".product-form__add-btn").classList.add("sticky-atc");
            document.querySelector(".product-form__swatch__items").classList.add("sticky-variant");
            document.querySelector("back-to-top-button").classList.add("move-up");
        } else {
            document.querySelector(".product-form__add-btn").classList.remove("sticky-atc");
            document.querySelector(".product-form__swatch__items").classList.remove("sticky-variant");
            document.querySelector("back-to-top-button").classList.remove("move-up");
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initialiseDescriptionLink();
    mobileStickyATC();
})